import React from 'react';
import { IButton } from './types.type';

export const Button = ({ onClick, value, children, className = '' }: IButton) => (
  <button
    type="button"
    onClick={onClick}
    className={`
      flex justify-center items-center gap-[8px]
      h-[52px] px-[30px] py-[13px] w-full
      rounded-[32px] border border-gray-500
      bg-gray-400 text-base-black font-body font-medium
      transition hover:opacity-90 active:opacity-80
      hover:shadow-[0_0_0_4px_rgba(93,225,255,0.20)]
      ${className}
    `}
  >
    {children || value}
  </button>
);
